"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const UnsubscribeRequest_1 = __importDefault(require("./UnsubscribeRequest"));
const Serializer_1 = require("../../../Serializer");
const StreamID_1 = require("../../../../src/utils/StreamID");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class UnsubscribeRequestSerializerV2 extends Serializer_1.Serializer {
    toArray(unsubscribeRequest) {
        return [
            VERSION,
            ControlMessage_1.default.TYPES.UnsubscribeRequest,
            unsubscribeRequest.requestId,
            unsubscribeRequest.streamId,
            unsubscribeRequest.streamPartition,
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, streamId, streamPartition,] = arr;
        return new UnsubscribeRequest_1.default({
            version,
            requestId,
            streamId: (0, StreamID_1.toStreamID)(streamId),
            streamPartition
        });
    }
}
exports.default = UnsubscribeRequestSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.UnsubscribeRequest, new UnsubscribeRequestSerializerV2());
//# sourceMappingURL=UnsubscribeRequestSerializerV2.js.map